import { reactive } from 'vue';

const SOUND_KEY = 'metronome-sound';
const TIME_SIGNATURE_KEY = 'metronome-time-signature';

const loadSound = () => {
  try {
    return localStorage.getItem(SOUND_KEY) || 'woodblock';
  } catch {
    return 'woodblock';
  }
};

const loadTimeSignature = () => {
  try {
    return localStorage.getItem(TIME_SIGNATURE_KEY) || '4/4';
  } catch {
    return '4/4';
  }
};

export const TIME_SIGNATURES = ['2/4', '3/4', '4/4', '5/4', '6/8', '7/8', '9/8', '12/8'];

export const metronomeStore = reactive({
  isOpen: false,
  isFullscreen: false,
  sound: loadSound(),
  timeSignature: loadTimeSignature(),

  setSound(sound) {
    this.sound = sound;
    try {
      localStorage.setItem(SOUND_KEY, sound);
    } catch {
      // ignora
    }
  },

  setTimeSignature(sig) {
    this.timeSignature = sig;
    try {
      localStorage.setItem(TIME_SIGNATURE_KEY, sig);
    } catch {
      // ignora
    }
  },

  openBar() {
    this.isOpen = true;
    this.isFullscreen = false;
  },

  openFullscreen() {
    this.isOpen = true;
    this.isFullscreen = true;
  },

  minimize() {
    this.isFullscreen = false;
  },

  close() {
    this.isOpen = false;
    this.isFullscreen = false;
  },

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.openBar();
    }
  }
});

export default metronomeStore;
